import script from "./AddStudent.vue?vue&type=script&setup=true&lang=js"
export * from "./AddStudent.vue?vue&type=script&setup=true&lang=js"

import "./AddStudent.vue?vue&type=style&index=0&id=7ffe2dc6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ffe2dc6"]])

export default __exports__